import { logger } from 'lib/analytics/logger'
import { EventSenderPlugin } from '.'
import { EventMetadata, SendEventData } from '../types'

export class DataDogLoggerPlugin extends EventSenderPlugin {
  constructor() {
    super('DataDogLogger')
  }

  sendEvent(event: SendEventData) {
    if (event.metadata?.error) {
      logger.error(event.label, event.metadata)
      return
    }

    logger.info(event.label, event.metadata)
  }

  updateMetadata(metadata: EventMetadata): void {
    logger.setMetadata(metadata)
  }
}
